import { COMPANY_FEATURES } from "@routebot/constants";

export const PARENT_RIDE_SKIP_FEATURE = COMPANY_FEATURES.PARENT_RIDE_SKIP || "parentRideSkip";

export const RIDE_SKIP_SERVICE_KINDS = {
  VEHICLE_ROUTE: "VEHICLE_ROUTE",
  BUNDLED_ROUTE: "BUNDLED_ROUTE",
};

export const isRideSkipUiEnabled = (company) => company?.features?.[PARENT_RIDE_SKIP_FEATURE] === true;
